<div class="wrapper" (click)="onShowDetails()">
  <div class="titleContainer">
    <tun-scrollable-text class="title" [text]="searchMusicCollection.title"></tun-scrollable-text>
  </div>
</div>
